/*
  WHIFF V2 | tuotekortin ohjaimet (snippets/whiff-card.liquid)

  Kortin kokopainike tai sävyvalikko valitsee saman vaihtoehdon kortin piilotetusta Kingin
  valitsimesta (variants-set). King päivittää lomakkeen variantti-ID:n ja Add to Cart -painikkeen
  tilan, ja Kingin lomake lisää tuotteen ostoskoriin AJAXilla. Tämä tiedosto vaihtaa lisäksi
  kortin hinnan valitun vaihtoehdon hintaan. Ei omaa ostoskorilogiikkaa.
  Suoritetaan vain kerran (window.WhiffCard), vaikka useampi osio lataisi tiedoston.
*/
(function () {
  if (window.WhiffCard) return;
  window.WhiffCard = { version: 1 };

  function selectInKing(picker, valueId) {
    var input = picker.querySelector('optionset input[data-option-value-id="' + valueId + '"]');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var select = picker.querySelector('select');
    if (select) {
      var option = select.querySelector('option[data-option-value-id="' + valueId + '"]');
      if (!option) return false;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function setPrice(card, html) {
    var price = card.querySelector('[data-wf-card-price]');
    if (price && typeof html === 'string') price.innerHTML = html;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wf-card-size]');
    if (!button) return;
    var card = button.closest('[data-wf-card]');
    if (!card) return;
    if (button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-pressed') === 'true') return;
    var picker = card.querySelector('variants-set');
    if (!picker || !selectInKing(picker, button.dataset.optionValueId)) return;
    card.querySelectorAll('[data-wf-card-size]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });
    setPrice(card, button.dataset.priceHtml);
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-wf-card-select]');
    if (!select) return;
    var card = select.closest('[data-wf-card]');
    var option = select.selectedOptions && select.selectedOptions[0];
    if (!card || !option) return;
    var picker = card.querySelector('variants-set');
    if (!picker || !selectInKing(picker, option.dataset.optionValueId)) return;
    setPrice(card, option.dataset.priceHtml);
  });
})();

/* =====================================================================
   WHIFF-kortti: front image -mitoitus (custom.front_image)
   PhotoRoomin PNG voi sisältää läpinäkyvää tilaa tuotteen ympärillä, ja tiedostojen
   mittasuhteet vaihtelevat. object-fit: contain sovittaisi koko PNG:n (myös läpinäkyvän
   reunuksen), jolloin tuote jää pieneksi. Tämä lukee kerran kuvan näkyvien pikselien rajat
   (alfa) ja asettaa kuvan niin, että itse tuote täyttää kuva-alueen sisäreunat keskellä.
   Ei rajausta eikä venytystä: kuva skaalataan omassa kuvasuhteessaan. Mittaus tallennetaan
   selaimeen, joten seuraavalla sivulla tuote on heti oikean kokoinen.
   Koskee vain kuvia, joilla on luokka wf-card__image--front. Muu kortti ei muutu.
   ===================================================================== */
(function () {
  if (window.__wfFrontFit) return;
  window.__wfFrontFit = true;

  var PAD_X = 0.10;   /* tyhjä tila sivuilla, osuus kuva-alueen leveydestä */
  var PAD_Y = 0.08;   /* tyhjä tila ylä- ja alareunassa, osuus korkeudesta */
  var RATIO = 1.25;   /* kuva-alue 4:5 (korkeus / leveys) */
  var ALPHA = 24;     /* tätä läpinäkyvämmät pikselit eivät ole tuotetta */
  var SAMPLE = 256;   /* mittauskuvan leveys */
  var memo = {};

  function keyOf(src) {
    try {
      var u = new URL(src, location.href);
      u.searchParams.delete('width');
      u.searchParams.delete('height');
      return u.pathname + u.search;
    } catch (e) { return src; }
  }
  function load(key) {
    if (memo[key]) return memo[key];
    try { var v = JSON.parse(localStorage.getItem('wf-front:' + key)); if (v) memo[key] = v; return v; } catch (e) { return null; }
  }
  function save(key, box) {
    memo[key] = box;
    try { localStorage.setItem('wf-front:' + key, JSON.stringify(box)); } catch (e) {}
  }

  function bounds(source) {
    var w = SAMPLE;
    var h = Math.max(1, Math.round(SAMPLE * source.naturalHeight / source.naturalWidth));
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(source, 0, 0, w, h);
    var data = ctx.getImageData(0, 0, w, h).data;
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (data[(y * w + x) * 4 + 3] > ALPHA) {
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        }
      }
    }
    if (x1 < 0) return null;
    return { x: x0 / w, y: y0 / h, w: (x1 - x0 + 1) / w, h: (y1 - y0 + 1) / h, r: source.naturalWidth / source.naturalHeight };
  }

  /* Mittaus näkyvästä kuvasta. Jos selain ei salli lukea sitä (eri osoite), ladataan pieni kopio CORS-pyynnöllä. */
  function measure(img, done) {
    try { return done(bounds(img)); } catch (e) {}
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () { try { done(bounds(probe)); } catch (e) { done(null); } };
    probe.onerror = function () { done(null); };
    try {
      var u = new URL(img.currentSrc || img.src, location.href);
      u.searchParams.set('width', String(SAMPLE));
      probe.src = u.toString();
    } catch (e) { done(null); }
  }

  function apply(img, b) {
    if (b && b.w > 0 && b.h > 0) {
      img._wfBox = b;
      var box = img.parentNode;
      if (box && getComputedStyle(box).position === 'static') box.style.position = 'relative';
      /* Kuva-alueen oma muoto: kortissa 4:5, tuotesivulla näyttämön koko. Piilossa 4:5. */
      var ratio = (box && box.clientWidth > 0 && box.clientHeight > 0) ? box.clientHeight / box.clientWidth : RATIO;
      /* Yksiköt: kuva-alueen leveys 1 ja korkeus ratio. Kuvan leveys r, korkeus 1. */
      var s = Math.min((1 - 2 * PAD_X) / (b.w * b.r), (ratio * (1 - 2 * PAD_Y)) / b.h);
      var cx = (b.x + b.w / 2) * b.r * s;
      var cy = (b.y + b.h / 2) * s;
      var st = img.style;
      st.position = 'absolute';
      st.maxWidth = 'none';
      st.objectFit = 'fill';
      st.width = (b.r * s * 100).toFixed(3) + '%';
      st.height = (s / ratio * 100).toFixed(3) + '%';
      st.left = ((0.5 - cx) * 100).toFixed(3) + '%';
      st.top = ((ratio / 2 - cy) / ratio * 100).toFixed(3) + '%';
      st.transformOrigin = ((b.x + b.w / 2) * 100).toFixed(2) + '% ' + ((b.y + b.h / 2) * 100).toFixed(2) + '%';
      /* Tarkka kuva: selain valitsee srcsetistä version todellisen piirtoleveyden mukaan */
      var stage = img.parentNode && img.parentNode.clientWidth;
      if (stage) img.sizes = Math.ceil(stage * b.r * s) + 'px';
    }
    /* Tuotesivun kuva: mitoitetaan uudelleen, kun näyttämön koko muuttuu
       (desktopilla galleria saa lopullisen kokonsa vasta kuvan jälkeen) */
    if (b && !img._wfObserved && img.classList.contains('whiff-media-front') && window.ResizeObserver && img.parentNode) {
      img._wfObserved = true;
      var lastW = -1, lastH = -1;
      new ResizeObserver(function () {
        var p = img.parentNode;
        if (!p || !img._wfBox) return;
        if (p.clientWidth === lastW && p.clientHeight === lastH) return;
        lastW = p.clientWidth;
        lastH = p.clientHeight;
        apply(img, img._wfBox);
      }).observe(img.parentNode);
    }
    img.classList.add('is-fit');
  }

  function fit(img) {
    if (img.dataset.wfFit) return;
    var key = keyOf(img.getAttribute('src') || '');
    var known = load(key);
    if (known) { img.dataset.wfFit = '1'; apply(img, known); return; }
    if (!img.complete || !img.naturalWidth) return; /* odotetaan load-tapahtumaa */
    img.dataset.wfFit = '1';
    measure(img, function (b) { if (b) save(key, b); apply(img, b); });
  }

  function scan(root) {
    (root || document).querySelectorAll('img.wf-card__image--front:not([data-wf-fit])').forEach(fit);
  }

  document.addEventListener('load', function (event) {
    var t = event.target;
    if (t && t.tagName === 'IMG' && t.classList.contains('wf-card__image--front')) fit(t);
  }, true);
  document.addEventListener('error', function (event) {
    var t = event.target;
    if (t && t.tagName === 'IMG' && t.classList.contains('wf-card__image--front')) t.classList.add('is-fit');
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
    /* Tuotesivun näyttämö muuttaa kokoaan ikkunan mukana: mitoitus uudelleen */
  var refitTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(refitTimer);
    refitTimer = window.setTimeout(function () {
      document.querySelectorAll('img.wf-card__image--front[data-wf-fit]').forEach(function (img) {
        if (img._wfBox) apply(img, img._wfBox);
      });
    }, 150);
  });
  /* Myöhemmin lisätyt kortit: If You Like -suositukset, haku, Theme Editor */
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length) { scan(); return; }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* WHIFF: ennakkotilaus (lokakuu 2026). Valittu ennakkotilauskoko (data-preorder) näyttää tekstin,
   ottaa käyttöön ostoskoririvin ominaisuuden "Ennakkotilaus" ja piilottaa tuotesivun toimitusarvion.
   Muilla koilla mitään ei lisätä. Kingin lomake lähettää kentän itse. */
(function () {
  if (window.__whiffPreorder) return;
  window.__whiffPreorder = true;

  function syncScope(scope) {
    var chosen = scope.querySelector('[aria-pressed="true"][data-preorder="true"]');
    var on = !!chosen;
    scope.querySelectorAll('[data-whiff-preorder-note]').forEach(function (note) { note.hidden = !on; });
    scope.querySelectorAll('[data-whiff-preorder-input]').forEach(function (input) { input.disabled = !on; });
    if (scope.hasAttribute('data-whiff-buybox')) {
      var host = scope.closest('.shopify-section') || document;
      host.querySelectorAll('.whiff-delivery-box').forEach(function (box) { box.classList.toggle('is-preorder', on); });
    }
  }
  function syncAll() {
    document.querySelectorAll('[data-whiff-preorder-scope], [data-whiff-buybox]').forEach(syncScope);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; syncAll(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (m.type === 'attributes') {
        if (m.target.closest && m.target.closest('[data-whiff-preorder-scope], [data-whiff-buybox]')) { schedule(); return; }
      } else if (m.addedNodes.length) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed'] });
})();